export default class ErrorMessage {
    public message: string;
    public code: string;
    public showRefreshButton: boolean;

    constructor(message: string, code: string, showRefreshButton: boolean) {
        this.message = message;
        this.code = code;
        this.showRefreshButton = showRefreshButton;
    }
}